























import Vue from "vue";
import InformantDlg from "./InformantDlg";
export default InformantDlg;
